<template>
  <div>
    <VMenu
      v-if="getLogged"
      location="bottom"
    >
      <template v-slot:activator="{ props  }">
        <VBtn
          v-bind="props"
          icon="mdi-account-circle"
        >
        </VBtn>
      </template>
      <VList>
        <slot name="UserActions" />

        <ChangeLanguageBtn />
        <VListItem @click="resetPassword">
          <template v-slot:append>
            <VIcon>
              mdi-lock-reset
            </VIcon>
          </template>
          <VListItemTitle>{{ $t('auth.forget_password.reset_password') }}</VListItemTitle>
        </VListItem>
        <VListItem @click="logout">
          <template v-slot:append>
            <VIcon>
              mdi-logout
            </VIcon>
          </template>
          <VListItemTitle>{{ $t('auth.logout.logout') }}</VListItemTitle>
        </VListItem>
      </VList>
    </VMenu>
    <VBtn
      v-else
      class="mr-3"
      variant="outlined"
      color="black"
      :to="{ name: 'Login' }"
    >
      {{ $t('auth.login.login') }}
    </VBtn>
    <ResetPasswordDialog ref="resetPasswordDialog"/>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex'

export default {
  components: {
    ResetPasswordDialog: defineAsyncComponent(() => import('@/app/Auth/comp/ResetPasswordDialog.vue')),
    ChangeLanguageBtn: defineAsyncComponent(() => import('./ChangeLanguageBtn.vue')),
  },
  computed: {
    ...mapGetters('Auth', ['getUser','getLogged']),
  },
  methods: {
    logout () {
      this.$store.dispatch('Auth/Auth_logout')
    },
    async resetPassword () {
      await this.$refs.resetPasswordDialog.openDialog();
    }
  }
}
</script>
